import Cookies from 'js-cookie';

const tickers = Array.from(document.querySelectorAll('.js-ticker'));
const commerceTickers = Array.from(document.querySelectorAll('.js-ticker-commerce'));
const elements = Array.from(document.querySelectorAll('.js-ticker-btn'));
const commerceElements = Array.from(document.querySelectorAll('.js-ticker-commerce-btn'));
const cookieName = 'ticker_toggle';
const commerceCookieName = 'commerce_ticker_toggle';

if (!Cookies.get(cookieName)) {
	tickers.forEach(ticker => {
		ticker.classList.toggle('is-active');
	});
}

if (!Cookies.get(commerceCookieName)) {
	commerceTickers.forEach(ticker => {
		ticker.classList.toggle('is-active');
	});
}

if (elements) {
	elements.forEach(element => {
		element.addEventListener('click', toggle);
	});
}

if (commerceElements) {
	commerceElements.forEach(element => {
		element.addEventListener('click', commerceToggle);
	});
}

function toggle() {
	tickers.forEach(ticker => {
		ticker.classList.toggle('is-active');
		Cookies.set(cookieName, 'true');
		document.body.classList.remove('ticker-present');
	});
}

function commerceToggle() {
	commerceTickers.forEach(ticker => {
		ticker.classList.toggle('is-active');
		Cookies.set(commerceCookieName, 'true');
	});
}
